import { modifier } from 'ember-modifier';

const CHART_BOTTOM = 90;
const CHART_LEFT = 55;
const CHART_WIDTH = 569;
const DURATION = 600;

function easeOut(t: number): number {
  return 1 - (1 - t) ** 3;
}

let clipCounter = 0;

export default modifier(function restartAnimation(element: Element, [_key]: [unknown]) {
  const g = element as SVGGElement;
  const svg = g.closest('svg');
  if (!svg) return;

  const ns = 'http://www.w3.org/2000/svg';

  let defs = svg.querySelector('defs');
  if (!defs) {
    defs = document.createElementNS(ns, 'defs');
    svg.prepend(defs);
  }

  const clipId = `bar-clip-${++clipCounter}`;
  const clipPath = document.createElementNS(ns, 'clipPath');
  clipPath.setAttribute('id', clipId);

  const rect = document.createElementNS(ns, 'rect');
  rect.setAttribute('x', String(CHART_LEFT));
  rect.setAttribute('width', String(CHART_WIDTH));
  rect.setAttribute('y', String(CHART_BOTTOM));
  rect.setAttribute('height', '0');

  clipPath.appendChild(rect);
  defs.appendChild(clipPath);
  g.setAttribute('clip-path', `url(#${clipId})`);

  let startTime: number | null = null;
  let rafId: number;

  function frame(now: number) {
    if (startTime === null) startTime = now;
    const t = Math.min((now - startTime) / DURATION, 1);
    const height = CHART_BOTTOM * easeOut(t);
    rect.setAttribute('y', String(CHART_BOTTOM - height));
    rect.setAttribute('height', String(height));
    if (t < 1) rafId = requestAnimationFrame(frame);
  }

  rafId = requestAnimationFrame(frame);

  return () => {
    cancelAnimationFrame(rafId);
    clipPath.remove();
    g.removeAttribute('clip-path');
  };
});
